import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classes from './physicianMedicationReport.module.scss';
import { ReactComponent as ArrowIcon } from '../../../../assets/icons/arrow_sort.svg';
import Loader from '../../../_common/Loader/Loader';
import Utils from '../../../../utils/utils';

const PhysicianMedicationTable = ({
  data, header, className = '', onClick = () => {}, sort, sortBy, onSortBy, loading, type,
}) => {
  const onSort = (currentSortBy) => {
    const newSortType = { sortBy: currentSortBy, sort: 'asc' };

    if (sortBy === currentSortBy) {
      newSortType.sort = sort === 'desc' ? 'asc' : 'desc';
    }

    onSortBy(newSortType);
  };

  const trClass = [classes.tr];
  if (className) trClass.push(className);

  const arrowIcon = [classes.arrow_icon];
  if (sort === 'desc') arrowIcon.push(classes.arrow_icon_desc);

  return (
    data.length
      ? (
        <div className={classes.table_wrapper}>
          <div className={classes.table__border}>
            { loading && <Loader className={classes.table_loader} />}

            <table className={classes.table}>

              <thead className={classes.thead}>
                <tr className={classes.tr}>
                  {header.map((h) => (
                    <th
                      key={h.name}
                      className={[classes.th, h.isSelectable ? classes.th_selectable : null].join(' ')}
                      onClick={() => h.isSelectable && onSort(h.path)}
                    >
                      <span className={classes.th_title}>
                        {h.name}

                        <span className={classes.th_arrow}>
                          {h.isSelectable && h.path === sortBy && (
                          <ArrowIcon className={arrowIcon.join(' ')} />
                          )}
                        </span>
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody className={classes.tbody}>
                {data.map((d, i) => (
                  <tr
                    className={trClass.join(' ')}
                    key={`${d.name} ${i}`}
                  >
                    {header.map((h) => (
                      <td
                        className={classes.td}
                        key={h.name}
                      >
                        {h.type === 'report'
                          ? (
                            <div className={classes.total}>
                              <div style={{ color: '#1d2740' }}>
                                {+_.get(d, h.path) === 0 ? _.get(d, h.path) : _.get(d, h.path).toFixed(type === 'revenue' ? 2 : 0) }
                              </div>

                              <div style={h.comparePath
                                ? {
                                  color: +_.get(d, h.path) - +_.get(d, h.comparePath) === 0
                                    ? '#1e667d'
                                    : +_.get(d, h.path) - +_.get(d, h.comparePath) > 0
                                      ? '#06a006'
                                      : 'red',
                                  background: +_.get(d, h.path) - +_.get(d, h.comparePath) === 0
                                    ? '#cbe6ee'
                                    : +_.get(d, h.path) - +_.get(d, h.comparePath) > 0
                                      ? '#e4fee4'
                                      : '#ffe1e1',
                                }
                                : {}}
                              >
                                {h.comparePath
                                  ? `${+_.get(d, h.path) > +_.get(d, h.comparePath) ? '+' : ''}${(+_.get(d, h.path) - +_.get(d, h.comparePath)) === 0
                                    ? ' - '
                                    : (+_.get(d, h.path) - +_.get(d, h.comparePath)).toFixed(type === 'revenue' ? 2 : 0)}`

                                  : <span>&nbsp;</span>}
                              </div>
                            </div>
                          )

                          : (
                            <div style={{ cursor: 'pointer' }} onClick={() => onClick(d)}>
                              {_.get(d, h.path) ?? ' - '}
                            </div>
                          )}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )

      : (
        <div className={classes.notResult}>
          { loading && <Loader />}

          No Data Found
        </div>
      )
  );
};

PhysicianMedicationTable.propTypes = {
  header: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  sortBy: PropTypes.string,
  sort: PropTypes.oneOf(['asc', 'desc']),
  onSortBy: PropTypes.func,
};

export default PhysicianMedicationTable;
